import { AsyncPipe, NgClass, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { provideConfig } from '@spartacus/core';
import { CmsComponentData, GenericLinkModule, LinkModule, MediaModule } from '@spartacus/storefront';

import { DpFlexibleContentSectionComponent } from './components';
import { DpFlexibleContentSectionComponentService } from './services';
import { DpSectionBackgroundDirective } from '@app/core/cms-flex/directives';
import { DpCmsFlexComponentService } from '@app/core/cms-flex/services';

@NgModule({
  imports: [
    DpSectionBackgroundDirective,
    AsyncPipe,
    MediaModule,
    LinkModule,
    GenericLinkModule,
    NgClass,
    NgOptimizedImage
  ],
  exports: [DpFlexibleContentSectionComponent],
  declarations: [DpFlexibleContentSectionComponent],
  providers: [
    DpFlexibleContentSectionComponentService,
    provideConfig({
      cmsComponents: {
        FlexibleContentSectionComponent: {
          component: DpFlexibleContentSectionComponent,
          providers: [
            {
              provide: DpCmsFlexComponentService,
              useClass: DpFlexibleContentSectionComponentService,
              deps: [CmsComponentData, DomSanitizer]
            }
          ]
        }
      }
    })
  ]
})
export class DpFlexibleContentSectionModule {}
